export const paths = [
  { path: "/", label: "Dashboard" },
  { path: "/borrow", label: "Borrow" },
  { path: "/farm", label: "Farm" },
  { path: "/stake", label: "Stake" }
];
